import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, BOOKING_SCREENING_URL } from '../lib/tracking';

export default function OutcomeSection() {
  const outcomes = [
    {
      step: '01. UDBYTTE',
      title: 'Hvordan føles hverdagen, når problemet fylder mindre?',
      description: 'Forestil dig at vågne op uden den knugende uro i brystet. At have ro i nervesystemet, tillid til dine egne beslutninger og mentalt overskud til familien, relationerne og dit arbejdsliv.',
      icon: 'fa-solid fa-seedling',
    },
    {
      step: '02. FORDELE',
      title: 'Hvilke konkrete forandringer kan et forløb skabe?',
      description: 'Gennem samtaleterapi og målrettede øvelser lærer du at genkende kroppens signaler i tide, sige til og fra uden skyldfølelse og afvæbne de mønstre, der før holdt dig fast.',
      icon: 'fa-solid fa-sparkles',
    },
    {
      step: '03. EGENSKABER',
      title: 'Hvordan arbejder Kim Palasz i praksis?',
      description: 'Med 12 års klinisk erfaring som Psykoterapeut MPF og hypnoterapeut kombinerer Kim anerkendende samtaleterapi, NLP og neuroaffektiv traumeterapi – altid i dit eget tempo og med 100% tryghed.',
      icon: 'fa-solid fa-hand-holding-heart',
    },
  ];

  return (
    <section className="py-20 sm:py-24 bg-[#D9DDE2] border-y border-[#D9DDE2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-3">
            Mennesket før metoden
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#5A232E] tracking-tight">
            Fra konstant overlevelse til et liv i balance
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#6c7480] leading-relaxed">
            Vi starter altid med det liv, du ønsker at leve. Metoderne og fagligheden er blot midlet til at nå derhen.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {outcomes.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-8 border border-[#D9DDE2] shadow-xs flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between mb-6">
                  <span className="text-xs font-bold tracking-wider text-[#5A232E] uppercase bg-[#ECEEF1] px-3 py-1 rounded-full border border-[#D9DDE2]">
                    {item.step}
                  </span>
                </div>
                <h3 className="font-display text-xl text-[#5A232E] mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-[#6c7480] leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Bridge */}
        <div className="mt-14 text-center">
          <a
            href={BOOKING_SCREENING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_booking_click', { location: 'outcome_section' })}
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-sm shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 no-break whitespace-nowrap"
          >
            <i className="fa-solid fa-calendar-check" aria-hidden="true" />
            <span>Book en gratis afklaringssamtale</span>
          </a>
          <p className="text-xs text-[#6c7480] mt-3">
            20 minutters uforpligtende samtale over telefon eller online · 100% uforpligtende
          </p>
        </div>
      </div>
    </section>
  );
}
